import { useLanguageData } from '@/common/hooks/useLanguageData';
import ResetPasswordModal from '../ResetPasswordModal';
import {
	AuthError,
	AuthFormBottom,
	AuthFormEl,
	AuthFormFields,
	AuthFormRoot,
} from '../authModal.styles';
import AuthEmailField from './components/AuthEmailField';
import AuthLoginPasswordField from './components/AuthLoginPasswordField';
import AuthPasswordRegisterFields from './components/AuthPasswordRegisterFields';
import AuthFormStepLinks from './components/AuthFormStepLinks';
import AuthFormSubmitButton from './components/AuthFormSubmitButton';
import { useAuthForm } from './hooks/useAuthForm';
import { useResetPassword } from './hooks/useResetPassword';

const AuthForm = ({ mode = 'register', onSuccess }) => {
	const translations = useLanguageData('login');
	const isLogin = mode === 'login';

	const {
		email,
		setEmail,
		password,
		setPassword,
		confirmPassword,
		setConfirmPassword,
		error,
		normalizedEmail,
		handleSubmit,
		isAuthPending,
		isAuthSuccess,
		isSubmitDisabled,
	} = useAuthForm({ mode, onSuccess, translations });

	const {
		isResetModalOpen,
		resetEmail,
		setResetEmail,
		resetMessage,
		resetSuccess,
		isResetLoading,
		openResetModal,
		closeResetModal,
		handleResetSubmit,
		handleResetSuccessConfirm,
	} = useResetPassword(normalizedEmail, email);

	return (
		<>
			<AuthFormRoot>
				<AuthFormEl onSubmit={handleSubmit}>
					<AuthFormFields>
						{error && <AuthError>{error}</AuthError>}
						<AuthEmailField
							email={email}
							onEmailChange={setEmail}
							isAuthPending={isAuthPending}
							isAuthSuccess={isAuthSuccess}
							translations={translations}
						/>
						{isLogin ? (
							<AuthLoginPasswordField
								password={password}
								onPasswordChange={setPassword}
								isAuthPending={isAuthPending}
								isAuthSuccess={isAuthSuccess}
								translations={translations}
							/>
						) : (
							<AuthPasswordRegisterFields
								password={password}
								confirmPassword={confirmPassword}
								onPasswordChange={setPassword}
								onConfirmPasswordChange={setConfirmPassword}
								isAuthPending={isAuthPending}
								isAuthSuccess={isAuthSuccess}
								translations={translations}
							/>
						)}
						<AuthFormStepLinks
							isLogin={isLogin}
							onForgotPassword={openResetModal}
							translations={translations}
						/>
					</AuthFormFields>
					<AuthFormBottom>
						<AuthFormSubmitButton
							mode={mode}
							isAuthPending={isAuthPending}
							isAuthSuccess={isAuthSuccess}
							isSubmitDisabled={isSubmitDisabled}
							translations={translations}
						/>
					</AuthFormBottom>
				</AuthFormEl>
			</AuthFormRoot>
			{isResetModalOpen && (
				<ResetPasswordModal
					email={resetEmail}
					resetMessage={resetMessage}
					isLoading={isResetLoading}
					isSuccess={resetSuccess}
					onEmailChange={setResetEmail}
					onSubmit={handleResetSubmit}
					onClose={closeResetModal}
					onConfirmSuccess={handleResetSuccessConfirm}
				/>
			)}
		</>
	);
};

export default AuthForm;
